export default __webpack_public_path__ + "static/media/AvenirNext-HeavyItalic.bf913fbf.woff";